import { Component, ViewChild } from '@angular/core';

import { BaseModal } from '../../modals/modal-base';
import { TargetValidationSubscription } from './target-validation-subscription';
import { TargetValidationService } from './target-validation.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { AdminConsentDialog, AdminConsentDialogArgs } from './admin-consent-dialog.component';


export class TargetValidationDialogArgs { 
    LastAuthzOK?: boolean;
    LastAuthzErrorCode?: string;
}

@Component({
    selector: 'dialog-target-validation',
    templateUrl: './target-validation-dialog.component.html',
    styleUrls: [
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css',
        './target-validation-dialog.component.scss'
    ]
})
export class TargetValidationDialog extends BaseModal<TargetValidationDialogArgs> {

    private args: TargetValidationDialogArgs;

    subscriptions: TargetValidationSubscription[];
    subscriptionId: string;
    addOperationInProgress: boolean;
    lastAuthzError: string;

    @ViewChild('adminConsent') private adminConsentDialog: AdminConsentDialog;
    modalSubscription: Subscription;

    constructor(
        private service: TargetValidationService,
        private location: Location
    ) {
        super();
        this.subscriptions = [];
        service.registerDialog(this);
    }

    onActivate(args: TargetValidationDialogArgs) {
        this.args = args;
        this.lastAuthzError = args.LastAuthzErrorCode;
        this.subscriptions = [];
        this.updateSubscriptions();
    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

    onClose() {
        this.location.go(this.service.getCleanUrl());
    }

    onAddSubscription() {
        this.addOperationInProgress = true;
        this.service.addSubscription(this.subscriptionId)
            .do(subscription => {
                subscription['btnDisable'] = true;
                subscription['pending'] = true;
                this.subscriptions.push(subscription);

                setTimeout(() => {
                    subscription['btnDisable'] = false;
                }, 4000);
            })
            .switchMap(subscription => this.service.authorizeSubscription(
                subscription,
                window.location.href,
                false))
            .subscribe({
                next: authorizationUrl => window.location.assign(authorizationUrl),
                error: error => {
                    console.error(error);
                    this.addOperationInProgress = false;
                }
            });
    }

    onRemoveSubscription(subscription: TargetValidationSubscription) {
        this.service.removeSubscription(subscription).subscribe({
            next: subscription => {
                let index = this.subscriptions.indexOf(subscription);
                if (index >= 0) {
                    this.subscriptions.splice(index, 1);
                }
            },
            error: error => console.error(error)
        });
    }

    onReauthorize(subscription: TargetValidationSubscription) {
        this.service
            .authorizeSubscription(
                subscription,
                window.location.href,
                false)
            .subscribe({
                next: authorizationUrl => window.location.assign(authorizationUrl),
                error: error => console.error(error)
            });
    }

    onGetAdminConsentUrl(subscription: TargetValidationSubscription) {
        let me = this;
        this.service
            .authorizeSubscription(subscription, window.location.href, true)
            .subscribe({
                next: authorizationUrl =>
                    me.showAdminConsentDialog(authorizationUrl),
                error: error => console.error(error)
            });
    }


    private updateSubscriptions() {
        this.service.getSubscriptions()
            .subscribe(
                (subscriptions) => {
                    this.subscriptions = subscriptions
                }
            );
    }

    private showAdminConsentDialog(adminConsentUrl: string) {
        let args = new AdminConsentDialogArgs();
        args.URL = adminConsentUrl;
        this.adminConsentDialog.showDialog(args);
    }

    private hideAdminConsentDialog() {
        this.adminConsentDialog.closeDialog();
    }

}



// WEBPACK FOOTER //
// ./src/app/main/target-validation/target-validation-dialog.component.ts